<discovery-download
  [data]="data"
  [innerContent]="innerContent"
  (previousNextDownloadEventEmitter)="previousNextDownloadEvent($event)"
></discovery-download>
